import * as sonbp from "sonbp";
import * as ifbase from "../base";

/**
 * 処理モード切換え
 * 処理モードに応じて以下を行う
 * ・リスナー・エディターを切り替える
 * ・レイヤーの操作可否を切り替える
 */
export function changeMode(ifdto: ifbase.ifDto, mode: string): void {

	console.debug("[sonbpIf-debug] changeMode", mode);

	let sel = ifdto.bpView.getListener();
	if (sel != null && sel.length > 0 && sel[0].length > 0 && sel[0][0] instanceof sonbp.listener.selector) {
		(sel[0][0] as sonbp.listener.selector).clear();
	}

	switch (mode) {
		case ifbase.constants.MODE_PHOTO_REGIST:
		case ifbase.constants.MODE_PHOTO_REPLACE:
			setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_PHOTO);

			if (ifdto.client == ifbase.constants.CLIENT_PC) {

				ifdto.bpView.setListener([ifdto.bpSelectorWithExchange, ifdto.bpFrontDrawer]);
				ifdto.bpSelectorWithExchange.setEditor([]);
			} else {

				ifdto.bpView.setListener([ifdto.bpSelectorWithExchangeSP, ifdto.bpFrontDrawer]);
				ifdto.bpSelectorWithExchangeSP.setEditor([]);
			}
			break;

		case ifbase.constants.MODE_PHOTO_MANI:
			setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_PHOTO);

			ifdto.bpView.setListener([ifdto.bpSelector, ifdto.bpFrontDrawer]);
			ifdto.bpSelector.setEditor([ifdto.bpClipImageEditor]);
			break;

		//case ifbase.constants.MODE_COMMENT_MANI:
		//	setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_FREE);

		//	ifdto.bpView.setListener([ifdto.bpSelector]);
		//	ifdto.bpSelector.setEditor([ifdto.bpTextEditor]);
		//	break;

		case ifbase.constants.MODE_GREETING_MANI:
			setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_FREE);

			ifdto.bpView.setListener([ifdto.bpSelector, ifdto.bpFrontDrawer]);
			ifdto.bpSelector.setEditor([ifdto.bpTextEditor]);
			break;

		case ifbase.constants.MODE_SENDER_MANI:
			setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_SENDER);

			ifdto.bpView.setListener([ifdto.bpSelector, ifdto.bpFrontDrawer]);
			ifdto.bpSelector.setEditor([ifdto.bpTextEditor]);
			break;

		case ifbase.constants.MODE_STAMP_MANI:
			setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_STAMP);

			ifdto.bpView.setListener([ifdto.bpSelector, ifdto.bpFrontDrawer]);
			ifdto.bpSelector.setEditor([ifdto.bpStampEditor]);
			break;

		case ifbase.constants.MODE_MYSTAMP_MANI:
			setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_STAMP);

			ifdto.bpView.setListener([ifdto.bpSelector, ifdto.bpFrontDrawer]);
			ifdto.bpSelector.setEditor([ifdto.bpStampEditor]);
			break;

		case ifbase.constants.MODE_FONTGENIC_MANI:
			setLayerMode(ifdto.bpView, ifbase.constants.LTYPE_STAMP);

			ifdto.bpView.setListener([ifdto.bpSelector, ifdto.bpFrontDrawer]);
			ifdto.bpSelector.setEditor([ifdto.bpStampEditor]);
			break;

		default:
			throw new Error("[sonbpIf-changeMode] invalid mode. [" + mode + "]");
			break;
	}

	ifdto.procMode = mode;

}

/**
 * 指定されたレイヤーのみを操作可能に切り替える
 * 2025年対応：配置済み画像の再編集可能 #28295
 */
function setLayerMode(v: sonbp.view, layerType: string): void {

	v._om._doc.pages[0].layers.forEach(layer => {

		const ltype = layer.info.vendor_property.ffpsc?.layer_type
		if (ltype == layerType) {

			layer.info.modeOff(sonbp.constant.editModeType.OPERATION_NG);

		} else if (ifbase.constants.LTYPES_CAN_RESELECT.includes(layerType)
				&& ifbase.constants.LTYPES_CAN_RESELECT.includes(ltype)) {

			// 「画像」「挨拶分」「差出人」「スタンプ」「Myステッカー」内は選択可能とする
			layer.info.modeOff(sonbp.constant.editModeType.OPERATION_NG);

		} else {

			layer.info.modeOn(sonbp.constant.editModeType.OPERATION_NG);
		}
	});
}

/**
 * SP画像編集モードの場合のみ画像枠を全面表示する
 */
export function zoomPhotoBox4SP(ifdto: ifbase.ifDto, boxId: string): void {

	if (ifdto.client != ifbase.constants.CLIENT_SP) return;

	if (ifdto.procMode == ifbase.constants.MODE_PHOTO_MANI) {

		if (!boxId) {
			throw new Error("[sonbpIf-zoomPhotoBox4SP] invalid boxId.");
		}
		zoomPhotoBox(ifdto, true, boxId);
	} else {
		zoomPhotoBox(ifdto, false, null);
	}
}

/**
 * 指定IDの画像枠を全面表示する
 */
function zoomPhotoBox(ifdto: ifbase.ifDto, zoomOn: boolean, boxId: string): void {

	let v = ifdto.bpView;

	let setShowMode = function (flg: boolean): void {
		let items: sonbp.object.groupItem[] = [];

		//画像枠・背景・白フチレイヤー以外は非表示切換え
		for (let i = 0; i < ifdto.bpView._om._doc.pages[0].layers.length; i++) {
			let lay = ifdto.bpView._om._doc.pages[0].layers[i];
			let layType = lay.info.vendor_property.ffpsc?.layer_type;
			if (layType != ifbase.constants.LTYPE_PHOTO && layType != ifbase.constants.LTYPE_BG && layType != ifbase.constants.LTYPE_AREA) {
				if (flg) lay.info.modeOn(sonbp.constant.editModeType.SHOW_NG);
				else lay.info.modeOff(sonbp.constant.editModeType.SHOW_NG);
			} else {

				items = ifbase.util.getItems(lay.items, function (item: sonbp.object.baseItem): boolean {
					return ifbase.util.chkIsPhotobox(item);
				}) as sonbp.object.groupItem[];
			}
		}

		//対象画像枠ID以外は非表示切換え
		for (let i = 0; i < items.length; i++) {
			let item = items[i];
			if (item.id != boxId) {

				if (flg) item.info.modeOn(sonbp.constant.editModeType.SHOW_NG);
				else item.info.modeOff(sonbp.constant.editModeType.SHOW_NG);
			}
		}

		//ページ下地の白塗り有無
		///v.style.isDrawPageBackground = !flg;
	};

	if (!zoomOn) {
		//全面表示解除
		if (v._dm.scaleRate != ifdto.normalScale.normalScaleRate || v._dm.drawPoint != ifdto.normalScale.normalDrawPoint) {
			v._dm.drawPoint = ifdto.normalScale.normalDrawPoint;
			v._dm.scaleRate = ifdto.normalScale.normalScaleRate;

			setShowMode(false);

			return;
		}
		return;
	}

	//枠のサイズ
	let refInfo = sonbp.tool.item.getRefInfo(v, boxId);
	let boxItem = refInfo.item as sonbp.object.groupItem;
	let boxRect = boxItem.rect;

	//View領域のサイズ
	let vrect = v._dm.getFixedViewRect();

	//枠を全面表示
	const pad = ifbase.constants.SP_PHOTO_MANI_PADDING;
	let sc = Math.min(vrect.width / (boxRect.width + pad), vrect.height / (boxRect.height + pad));
	v._dm.scaleRate = sc;

	let left = -boxRect.x1 + ((v._dm.viewDocSize.x - boxRect.width) / 2);
	let bottom = -boxRect.y1 + ((v._dm.viewDocSize.y - boxRect.height) / 2);
	//left += v._exp.defaultPositionAdjust[0] / sc;
	//bottom += v._exp.defaultPositionAdjust[1] / sc;

	let point = new sonbp.type.point(left, bottom);

	v._dm.drawPoint = new sonbp.type.point(point.x, point.y);

	//console.debug("zoomPhotoBox", v._dm.scaleRate, v._dm.drawPoint);

	setShowMode(true);
}